<div class="container">
  <app-general-header title="Resources" />
  <div class="card border-0 p-3">
    <app-resources-subnav />
    <div class="card-body">
      <app-online-course-list></app-online-course-list>
    </div>
  </div>
</div>
